import { mantineColorsPalette } from './color';
import { createTheme } from '@mantine/core';
const mantine = createTheme({
    colors: mantineColorsPalette,
    primaryColor: 'primary',
});
export default mantine;
